import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { DtmToastComponent } from "../dtm-toast/dtm-toast.component";

@Component({
    selector: "dtm-ui-boundary-violation-toast",
    standalone: true,
    imports: [NgIf],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./boundary-violation-toast.component.html",
    styleUrls: ["./boundary-violation-toast.component.scss"],
})
export class BoundaryViolationToastComponent extends DtmToastComponent {}
